import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=3d0e3c41&scoped=true"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=3d0e3c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e3c41",
  null
  
)

export default component.exports